export const interiorPortfolioImages = [
  { src: '/images/interior/bedroom-2.jpg', caption: 'Luxury Bedroom' },
  { src: '/images/interior/bedroom-9.jpg', caption: 'Contemporary Bedroom' },
  {
    src: '/images/interior/classic-interior-pune.jpg',
    caption: 'Classic Interior at Pune',
  },
  {
    src: '/images/interior/entry-foyer-sarthana.jpg',
    caption: 'Entry Foyer at Sarthana',
  },
  { src: '/images/interior/home-theatre.jpg', caption: 'Home Theatre' },
  {
    src: '/images/interior/hospital-waiting.jpg',
    caption: 'Hospital Waiting Area',
  },
  { src: '/images/interior/kitchen-3.jpg', caption: 'Modern Kitchen' },
  { src: '/images/interior/living-room.jpg', caption: 'Living Room' },
  { src: '/images/interior/office-2.jpg', caption: 'Office Interior' },
  { src: '/images/interior/sitting-room.jpg', caption: 'Sitting Room' },
  { src: '/images/interior/hero-interior.jpg', caption: 'Luxury Room' },
  { src: '/images/interior/interior-photo-1.jpeg', caption: 'Master Bedroom' },
  {
    src: '/images/interior/interior-photo-2.jpeg',
    caption: 'Double height living space ',
  },
  {
    src: '/images/interior/interior-photo-3.jpeg',
    caption: 'Foyer',
  },
  {
    src: '/images/interior/interior-photo-4.jpeg',
    caption: 'Classic Bedroom',
  },
  {
    src: '/images/interior/interior-photo-5.jpeg',
    caption: 'Ultra Modern bedroom',
  },
  {
    src: '/images/interior/interior-photo-6.jpeg',
    caption: 'Luxurios Bedroom',
  },
];
